import React from "react";
import { Box, Typography, Avatar, Card, CardContent, Grid, Rating } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const reviews = [
    {
        name: "Nagaswathi Pisupati",
        avatar: "https://via.placeholder.com/50/green/fff?text=N", // Replace with actual image
        rating: 5,
        feedback:
            "You are giving training with lots of patience... The person who has zero knowledge can understand your concepts very well. You are also explaining small small concepts that no one will explain. Thank you so much 🙏🙏",
    },
    {
        name: "Nomula Laxmi",
        avatar: "https://via.placeholder.com/50/blue/fff?text=L", // Replace with actual image
        rating: 5,
        feedback:
            "I really enjoyed this training. No one can teach like Raj sir. Your training session was excellent! Your energy and enthusiasm were infectious, and you kept us engaged throughout the session. Thank you for your dedication to making this training a success.",
    },
    {
        name: "Siddhant Kushwaha",
        avatar: "https://via.placeholder.com/50/red/fff?text=S", // Replace with actual image
        rating: 5,
        feedback:
            "I have got a job as a Technical Lead. I am from Non-IT and thought it would be difficult to get a job in core IT, but your training helped me tremendously. I really thank you for all your support.",
    },
];

const StudentsReviews = () => {
    return (
        <Box sx={{ py: 5, textAlign: "center" }}>
            {/* Title */}
            <Typography variant="h4" fontWeight="bold">
                What Our <span style={{ color: "red" }}>Students' Say?</span>
            </Typography>
            <Typography variant="body1" sx={{ color: "gray", mb: 3 }}>
                Click on the reviews to see the full feedback from our 1000+ users on Google
            </Typography>

            {/* Swiper Carousel */}
            <Swiper
                modules={[Pagination]}
                spaceBetween={20}
                slidesPerView={1}
                pagination={{ clickable: true }}
                breakpoints={{
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
                style={{ maxWidth: "1200px", paddingBottom: "20px" }}
            >
                {reviews.map((review, index) => (
                    <SwiperSlide key={index}>
                        <Card
                            sx={{
                                width: 350, 
                                height: 250,
                                mx: "auto",
                                p: 2,
                                borderRadius: 3,
                                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                textAlign: "left", // Ensure left alignment
                            }}
                        >
                            <CardContent>
                                {/* Avatar and Name */}
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <Avatar src={review.avatar} alt={review.name} />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            {review.name}
                                        </Typography>
                                        <Rating value={review.rating} readOnly /> {/* Colored stars */}
                                    </Grid>
                                </Grid>
                                {/* Review Content */}
                                <Typography variant="body2" sx={{ mt: 2, color: "gray" }}>
                                    {review.feedback}
                                </Typography>
                            </CardContent>
                        </Card>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
};

export default StudentsReviews;
